export interface HostElementKeyParts {
  readonly sessionId: string;
  readonly configId: string;
  readonly nodeId: string;
}

const encodeSegment = (value: string): string => `${value.length}:${value}`;

export interface BindingDedupIdentity {
  readonly blockId: string;
  readonly eventBindingId: string;
}

/**
 * Appends a binding identity to an out-of-the-box dedupe key. The
 * prefix cannot appear in an out-of-the-box key, so the two never match.
 */
export function appendBindingDedupKey(
  base: string,
  binding: BindingDedupIdentity,
): string {
  return `${base}\u0000binding:${encodeSegment(binding.blockId)}:${encodeSegment(
    binding.eventBindingId,
  )}`;
}

export const composeHostElementKey = ({
  sessionId,
  configId,
  nodeId,
}: HostElementKeyParts): string =>
  `hostElement:${encodeSegment(sessionId)}:${encodeSegment(
    configId,
  )}:${encodeSegment(nodeId)}`;

export interface FlowElementKeyParts {
  readonly sessionId?: string;
  readonly configId?: string;
  readonly stepIndex?: number;
  readonly nodeId: string;
}

/**
 * Flow-host fire-once key:
 * `<flowSessionId>::<dslConfigId>::<stepIndex>::<nodeId>`. Missing
 * segments fall back to their `no-*` placeholder so a node rendered
 * outside a provider still gets a stable key.
 */
export const composeFlowElementKey = ({
  sessionId,
  configId,
  stepIndex,
  nodeId,
}: FlowElementKeyParts): string =>
  `${sessionId ?? 'no-session'}::${configId ?? 'no-cfg'}::${
    stepIndex ?? 'no-idx'
  }::${nodeId}`;
